import { render, staticRenderFns } from "./PapelSegurancaLoteDetalhes.vue?vue&type=template&id=a7cbd35a&"
import script from "./PapelSegurancaLoteDetalhes.vue?vue&type=script&lang=js&"
export * from "./PapelSegurancaLoteDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./PapelSegurancaLoteDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports